import { Link } from 'react-router-dom'
import Submission from './Submission'
import SubmissionHeader from './SubmissionHeader'
import QuizHeader from './QuizHeader'
import NextButton from './NextButton'
import QuestionList from './QuestionList'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'

/*eslint-disable */

const Quiz = ({ url, ...props }) => {
  console.log('leart13 QUIZ')

  const language = props.language || {}
  const dispatch = useDispatch()

  useEffect(() => {
    console.log(props, 'com props')
  }, [])

  return (
    <div>
      <Header
        cn='container-fluid'
        theme={props.theme.theme}
        language={props.language}
      >
        {props.id ? (
          <Link to={`${url}/quiz?index=0`} className='btn btn-default'>
            <span className='btn-text'>
              {status === 1
                ? language.courses
                  ? language.courses.view_submissions
                  : null
                : status === -1
                ? language.courses
                  ? language.courses.resume_quiz
                  : null
                : language.courses
                ? language.courses.take_quiz
                : null}
            </span>
          </Link>
        ) : null}

        <Link to='/learning-plan' className='btn btn-default'>
          <span className='btn-text'>
            {language.general ? language.general.back : null}
          </span>
        </Link>
      </Header>

      <div>
        <div className='container-fluid'>
          <SubmissionHeader {...props} />
        </div>
        <div className='container-fluid'>
          <Submission {...props} />
        </div>
      </div>
    </div>
  )
}
export default Quiz
